import {Injectable} from '@angular/core';
import {EntityClass} from '../entity.class';
import {entityDecorator} from '../entity.decorator';

@Injectable()
@entityDecorator({
  url: 'api/mentalseal/v1/admin',
  name: 'admin',
  idName: 'adminId',
  protobufJSON: require('assets/protobuf/mentalseal/mentalseal.json'),
  protobufModule: 'Admin'
})
export class MentalsealAdminService extends EntityClass {

}



// WEBPACK FOOTER //
// D:/taile-operate/BLACK-WIDOW/ng-src/app/services/entity-base/entity-service/mentalseal-admin.service.ts